import { render } from "./MenuGroups.vue?vue&type=template&id=8ae890d6"
import script from "./MenuGroups.vue?vue&type=script&lang=js"
export * from "./MenuGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__